import { useContext } from "react";
import WhiteLabelContext from "student-front-commons/src/components/WhitelabelContext";
import FlexColumn from "../../../core/FlexColumn";
import HeaderContainer from "../../../core/HeaderContainer";
import Separator from "../../../core/Separator";
import TranslatedText from "../../../core/TranslatedText";
import TestHeader from "../TestHeader";
import TestPanel from "../TestPanel";
import PlacementTestCodeForm from "./PlacementTestCodeForm";

export default function PlacementTestCodeScene() {
  const whitelabelContext = useContext(WhiteLabelContext);

  return (
    <div>
      <HeaderContainer />
      <TestHeader color={whitelabelContext.primaryColor} />
      <Separator size="lg" />
      <TranslatedText
        as="span"
        translateKey="placementTest.code.title"
        style={{
          color: "#fff",
          fontSize: "20px",
          fontWeight: "bold",
          textAlign: "center",
          display: "block",
        }}
      />
      <TestPanel width="640px" marginTop="40px" style={{ position: "relative" }}>
        <FlexColumn alignItems="center">
          <img
            src={whitelabelContext.logoUrl}
            alt="School logo"
            width="300px"
          />
          <Separator size="lg" />
          <PlacementTestCodeForm />
        </FlexColumn>
      </TestPanel>
    </div>
  );
}
